module.exports = __webpack_public_path__ + "static/img/corporation-credit1.0820a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/corporation-credit1.png
// module id = uhNf
// module chunks = 0